import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import Legacy from "./sections/Legacy";
import Leadership from "./sections/Leadership";
import Partners from "./sections/Partners";
import Share from "./sections/Share";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <Legacy />
      <Leadership />
      <Partners />
      <Share />
      <Footer />
    </div>;
}